import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
// IMPORT PACKAGE REFERENCES
import React from 'react';
import { formatDateShort } from '../../utils/dateUtils';

// COMPONENT
const AnalysisColumns = ({ status, uid, name, created, updated, productName, vendorName }) => {
    return (
        <div className="container">
            <div className="row">
                <div className="col-sm">
                    <h6>{name || productName || vendorName || 'N/A'}</h6>
                </div>
                <div className="col-sm">{status}</div>
                <div className="col-sm">{uid}</div>
                <div className="col-sm">{updated ? formatDateShort(updated) : '-'}</div>
                <div className="col-sm">{created ? formatDateShort(created) : '-'}</div>
            </div>
        </div>
    );
};

AnalysisColumns.propTypes = {
    uid: PropTypes.string,
    name: PropTypes.string,
    created: PropTypes.number,
    updated: PropTypes.number,
    status: PropTypes.string,
    productName: PropTypes.string,
    vendorName: PropTypes.string,
};

const AnalysesListItem = props => {
    return (
        <Link to={{ pathname: `/analysis-viewer/${props.id}` }} className="list-group-item-action">
            <AnalysisColumns {...props} />
        </Link>
    );
};

AnalysesListItem.propTypes = {
    id: PropTypes.string,
};

export { AnalysesListItem };
